<template>
  <SelectInput v-model="value" :cols="cols" :label="resolvedLabel" :options="PLAN_OPTIONS" :add-empty="false" />
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })

const emit = defineEmits(['update:modelValue', 'change'])
const props = defineProps({
  modelValue: { default: 1 },
  cols: { default: '4' },
  label: { type: String, default: '' }
})

const resolvedLabel = computed(() => props.label || t('components.reports.plans'))
const PLAN_OPTIONS = computed(() => [
  { text: t('components.planSelect.all'), value: 0 },
  { text: t('components.planSelect.operation'), value: 1 },
  { text: 'Clipping', value: 2 }
])

const value = computed({
  get: () => props.modelValue,
  set: (v) => {
    emit('update:modelValue', v)
    emit('change', v)
  }
})
</script>
